import { Box, Paper, Typography } from '@mui/material'
import { usePlanningStore } from '@planning/AppProvider'
import { UnNumbersAutoComplete } from '@planning/components/dangerous-goods/UnNumbersAutoComplete'
import { YesNoChipBox } from '@planning/components/dangerous-goods/YesNoChipBox'
import { useTranslate } from '@tolgee/react'
import { observer } from 'mobx-react-lite'
import { useCallback, useEffect } from 'react'
import { DangerousGoodsSubFormStore } from '../stores/DangerousGoodsSubFormStore'
import { DangerousGoodsAutocomplete } from './DangerousGoodsAutocomplete'
import { LabelsAutocomplete } from './LabelsAutocomplete'

export const DangerousGoodsSubForm = observer(
  ({ store }: { store: DangerousGoodsSubFormStore }) => {
    const { t } = useTranslate()
    const { dangerousGoodsDefinitionDataStore } = usePlanningStore()

    useEffect(() => {
      dangerousGoodsDefinitionDataStore.setPageSize(25)
    }, [dangerousGoodsDefinitionDataStore])

    const handleUNNumbersInputChange = useCallback(
      (newValue?: string) => {
        dangerousGoodsDefinitionDataStore.setFilter(newValue)
      },
      [dangerousGoodsDefinitionDataStore],
    )

    return (
      <Paper variant='outlined' sx={{ p: '1rem' }}>
        <Box display='flex' alignItems='center' justifyContent='space-between'>
          <Typography variant='body1' fontWeight='bold'>
            {t('dangerousGoods', 'Dangerous goods')}?
          </Typography>
          <YesNoChipBox
            activeOption={store.isDangerous.value ? 'Yes' : 'No'}
            onClickYes={() => store.isDangerous.setValue(true)}
            onClickNo={() => store.isDangerous.setValue(false)}
          />
        </Box>
        {store.isDangerous.value && (
          <>
            <DangerousGoodsAutocomplete fieldStore={store.imoClasses} required />
            <UnNumbersAutoComplete
              enableSelect={store.isDangerous.value}
              onInputChange={handleUNNumbersInputChange} // Used to search from API
              options={dangerousGoodsDefinitionDataStore.pageItems} // Load from API
              onUnNumbersChange={newValues => {
                store.setSelectedUnNumbers(newValues)
              }}
              selectedUnNumbers={store.unNumbers.value}
            />
            <LabelsAutocomplete fieldStore={store.otherLabels} required />
          </>
        )}
      </Paper>
    )
  },
)
